export default "__VITE_ASSET__08b88b45__"